<mat-card appearance="outlined">
    <ng-content></ng-content>
</mat-card>